import { alpha } from "@mui/material";

const useStyles = (theme) => ({
  textDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    fontColor: theme.palette.text.primary,
  },
  titleDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.shadow,
  },
  dataTime: {
    actionBar: {
      actions: ["accept"],
      sx: {
        "& .MuiButton-root": {
          color: theme.palette.easyLog.primary, // Cor do texto
          backgroundColor: "transparent", // Cor de fundo
          "&:hover": {
            backgroundColor: alpha(theme.palette.easyLog.primary, 0.05), // Cor de fundo ao passar o mouse
          },
        },
      },
    },
    accept: {
      sx: {
        backgroundColor: "#4CAF50", // Cor verde para o botão Aceitar
        color: "white",
        "&:hover": {
          backgroundColor: "#45a049", // Cor verde mais escuro no hover
        },
        borderRadius: "5px",
      },
    },
    digitalClockSectionItem: {
      sx: {
        borderRadius: "4px",
        "&.Mui-selected": {
          backgroundColor: theme.palette.easyLog.primary,
          color: "#fff",
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.easyLog.secondary,
        },
      },
    },
    day: {
      sx: {
        "&.Mui-selected:focus": {
          backgroundColor: theme.palette.easyLog.primary, // Mantém a cor ao clicar
        },
        "&.Mui-selected": {
          backgroundColor: theme.palette.easyLog.primary,
          color: "#fff",
          fontWeight: 500,
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.easyLog.secondary,
        },
      },
    },
    desktopPaper: {
      sx: {
        backgroundColor: theme.palette.background.default,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para desktop
    mobilePaper: {
      sx: {
        backgroundColor: theme.palette.background.paperNotification,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para mobile
  },
  datePicker: {
    "& .MuiButton-root": { backgroundColor: "purple" }, // Cor dos botões do pop-up
    "& .MuiPickersDay-root": { "&::selected": { backgroundColor: "blue" } }, // Cor dos dias no calendário
    "& .Mui-selected": { backgroundColor: "red!important" }, // Cor do dia selecionado
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "blue" }, // Cor da borda padrão
      "&:hover fieldset": { borderColor: "red" }, // Cor da borda ao passar o mouse
      "&.Mui-focused fieldset": { borderColor: "green" }, // Cor ao focar
    },
    "& .MuiInputLabel-root": { color: "purple" }, // Cor do label
    "& .MuiInputLabel-root.Mui-focused": { color: "green" }, // Cor do label ao focar
  },
  menuItem: {
    fontSize: "0.875rem",
    fontWeight: 500,

    "&.Mui-selected": {
      borderRadius: "4px",
      background: theme.palette.easyLog.primary,
      color: "white",
      "&:hover": {
        background: alpha(theme.palette.easyLog.primary, 0.8),
      },
    },
  },

  paperPoover: {
    "& .MuiPopover-paper": {
      marginTop: "5px",
      boxShadow: "0px 4px 14px 0px  #0000002c",
      padding: "10px",
      overflow: "visible",
    },
  },
});

export default useStyles;
